module.exports = __webpack_public_path__ + "static/media/friend.71fb5ce3.png";